import script from "./ChangeStatusModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeStatusModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__